'use client';

import { startGameDownload } from '@/features/games/shared/helpers/start-game-download';
import type { PendingGateAction } from '@/features/auth/shared/state/pending-gate-action';

export const runPendingGateAction = (action: PendingGateAction): void => {
  switch (action.type) {
    case 'trialDownload':
      startGameDownload(action.sku, action.isDownload);
      return;
  }
};
